import {Stack} from 'src/design/atoms/Stack';
import React from 'react';
import {DirectoryCategories} from 'src/app/layout/Directory/DirectoryCategories';
import {
  SettingsDirectoryConfig,
  SidebarLinkSettings,
} from 'src/app/layout/Sidebar/SidebarLinksConfig';
import {PageHeader} from 'src/design/organisms/PageHeader';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';

export const SettingsDirectoryPage: React.FC = () => {
  useSetDocumentTitle('Settings');

  return (
    <ContentWrapper>
      <Stack gap="lg">
        <PageHeader>
          <PageHeader.Title
            icon={SidebarLinkSettings.icon}
            subtitle="Instance configuration and customization">
            Settings
          </PageHeader.Title>
        </PageHeader>
        <DirectoryCategories categories={SettingsDirectoryConfig} />
      </Stack>
    </ContentWrapper>
  );
};

routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.Settings(),
  element: <SettingsDirectoryPage />,
  isPrivate: true,
});
